// extracted by mini-css-extract-plugin
export default {"title":"YIZIMl4sgd","button":"_1PfSL3hH0I"};
    if(module.hot) {
      // 1648554129577
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  